import moment from "moment";

export function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

export function formatNumber(number) {
  return number.toFixed(2).replace(".", ",");
}

export function displayHour(time) {
  return moment().add(time, "minutes").format("HH:mm");
}

export function displayHourSelected(timeStamps) {
  return moment.unix(timeStamps).format("HH:mm");
}

export function isDesktop(window) {
  return window.innerWidth > 760;
}

export function sortWeight(datas) {
  return datas.sort((a, b) => {
    if (a.weightCategory > b.weightCategory) return 1;
    if (a.weightCategory < b.weightCategory) return -1;
    if (a.weight > b.weight) return 1;
    if (a.weight < b.weight) return -1;
  });
}

export const splitStrLang = (language) => {
  return language
    ? language.split("-")[1]
      ? language.split("-")[1].toLowerCase()
      : language.split("-")[0].toLowerCase()
    : "";
};

export function hasSearchedGroup(accessToken, searchedGroup) {
  if (accessToken && searchedGroup) {
    const decodedToken = JSON.parse(atob(accessToken.split('.')[1]));
    return decodedToken.groups.some(group => group.name === searchedGroup);
  } else {
    return 'No access token or group found';
  }
}

export const getCookieValue = (name) => {
  const cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return cookie ? cookie[2] : '';
};
